import styled from 'styled-components';
import { BaseButton } from '@app/components/common/BaseButton/BaseButton';
import { media } from '@app/styles/themes/constants';
import { BaseDivider } from '@app/components/common/BaseDivider/BaseDivider';
import { BaseTypography } from '@app/components/common/BaseTypography/BaseTypography';

export const NoticesOverlayMenu = styled.div`
  max-width: 15rem;

  .notifications-wrapper {
    display: flex;

    > .ant-space-item {
      display: flex;

      > div {
        display: flex;
        flex: 1;
        padding: 10px;
        align-items: center;
        color: #666;
        background-color: #efefef;

        .anticon, .ant-typography {
          color: #999;  
        }
      
        .ant-space-item:first-child {
          flex: 0 0 auto;
        }
        .ant-space-item:last-child {
          flex: 0 0 auto;
          align-self: flex-end;
          margin-left: auto;
        }

        &.new-notification {
          font-weight: 700;
          font-family: 'Onest';
          background-color: #fff;

          .ant-typography {
            color: #000;
          }

          .anticon, .ant-typography.title {
            color:#f00;
          }
        }
      }
    }
  }

  @media only screen and ${media.md} {
    max-width: 25rem;
  }
`;

export const SplitDivider = styled(BaseDivider)`
  margin: 0;
`;

export const LinkBtn = styled(BaseButton)`
  &.ant-btn {
    padding: 0;
    font-size: 0.875rem;
    height: unset;
    line-height: unset;
  }
`;

export const Btn = styled(BaseButton)`
  width: 100%;
`;

export const Text = styled(BaseTypography.Text)`
  display: block;
  text-align: center;
`;
